import UserPermissions from '../../../../permissions/constants/userPermissions';
import {
  getUnschedulingStopMessageKey,
  unscheduleStopFailedNotification,
  unscheduleStopSuccessNotification,
} from '../../../../notifications/scheduling/unscheduleStop';
import { ProjectStopUnscheduledDtoModelType } from '../../models';
import getAppEnv from '../../utils/getAppEnv';
import getAppRoot from '../../utils/getAppRoot';

const projectStopUnscheduledHandler = ({
  store, pendingSolution, success,
}: ProjectStopUnscheduledDtoModelType) => {
  const routeId = pendingSolution.assignAction?.targetRouteId;

  if (pendingSolution.assignAction.visitId != null && routeId != null) {
    const appEnv = getAppEnv(store);
    const appStore = getAppRoot(store);
    const id = String(pendingSolution.assignAction.visitId);
    const routeName = pendingSolution.assignAction.targetRouteName;
    const { visitName } = pendingSolution.assignAction;

    appEnv.closeMessage(getUnschedulingStopMessageKey(id));

    const showUnscheduling = appStore.account.hasPermission(UserPermissions.ASSIGN_DRIVERS_TO_ROUTES);

    if (!success) {
      if (showUnscheduling) {
        appEnv.notification(unscheduleStopFailedNotification(id, visitName, routeName, () => {
          appStore.ui.selectVisit(id);
          appStore.ui.selectRoute(String(routeId));
        }));
      }
    } else {
      // close stop info card if still open
      if (appStore.ui.selectedVisit?.id === id) {
        appStore.ui.selectVisit(null);
      }

      const handleButtonClick = () => appStore.ui.selectVisit(id);
      appEnv.notification(unscheduleStopSuccessNotification(id, visitName, routeName, showUnscheduling ? handleButtonClick : undefined));
    }
  }

  return () => {
    store.assignActionStatusDtos.delete(pendingSolution.assignAction.id);
    store.solutionStatusOnlyDtos.delete(pendingSolution.id);
  };
};

export default projectStopUnscheduledHandler;
